import * as moment from 'moment';
import { Moment } from 'moment';
import * as React from 'react';
import Button from 'reactstrap/lib/Button';
import { TR } from 'src/TextRes';
import FAIcon from '../fAIcon/FAIcon';
import './Calendar.css';
import Month from './Month';

// based on the work of Mikhail Novikov
// https://github.com/freiksenet/react-calendar
// https://github.com/freiksenet/react-calendar/blob/master/LICENSE

interface Props {
    weekNumbers?: boolean;
    locale?: string;
    yearHeaderFormat?: string;
    selected: Moment[];
    onCancel: () => void;
    onAccept: (newDates: Moment[]) => void;
}

interface State {
    year: number;
    newlySelected: Moment[];
}

export default class Calendar extends React.PureComponent<Props, State> {
    public static defaultProps = {
        locale: 'de',
        yearHeaderFormat: 'YYYY',
    };

    constructor(props: Props) {
        super(props);
        this.state = { year: moment().year(), newlySelected: [] };
    }

    public render() {
        const { selected } = this.props;
        const { year, newlySelected } = this.state;

        const start = moment(new Date(year, 0, 1, 0, 0));
        const months = Array(12)
            .fill(0)
            .map((n, i) => start.clone().add(n + i, 'months'));

        const isCurrentYear = moment().year() === year;
        const isinTwoYears = moment().year() + 2 === year;

        return (
            <>
                <div className="rc-Background" />
                <div className={'rc-Calendar'}>
                    <header key="header" className={'rc-Calendar-header'}>
                        <Button className={'closeCalendar'} onClick={this.onCancel}>
                            schließen
                        </Button>
                        {!isCurrentYear && <FAIcon icon="arrow-left" className={'prev'} onClick={this.prevYear} />}
                        {year}
                        {!isinTwoYears && <FAIcon icon="arrow-right" className={'next'} onClick={this.nextYear} />}
                    </header>
                    {months.map((date, i) => (
                        <Month
                            key={`month-${i}`}
                            date={date}
                            selected={selected}
                            newlySelected={newlySelected}
                            onToggle={this.onToggle}
                        />
                    ))}
                    <div className="rc-ButtonBar">
                        {this.state.newlySelected.length > 0 && (
                            <Button className="pull-left" onClick={this.deselectAll}>
                                alle abwählen
                            </Button>
                        )}
                        <Button onClick={this.onCancel}>{TR.calendar_cancel}</Button>
                        <Button onClick={this.onAccept}>{TR.calendar_add}</Button>
                    </div>
                </div>
            </>
        );
    }

    private onToggle = (day: Moment) => {
        const existing = this.state.newlySelected;
        const m = existing.filter((exi) => exi.isSame(day, 'day'));
        if (m.length > 0) {
            const filtered = existing.filter((exi) => !exi.isSame(day, 'day'));
            this.setState({ newlySelected: [...filtered] });
        } else {
            this.setState({ newlySelected: [...existing, day] });
        }
    };

    private deselectAll = () => {
        this.setState({ newlySelected: [] });
    };

    private onCancel = () => {
        this.props.onCancel();
    };

    private onAccept = () => {
        this.props.onAccept(this.state.newlySelected);
    };

    private nextYear = () => {
        this.setState({ year: this.state.year + 1 });
    };

    private prevYear = () => {
        this.setState({ year: this.state.year - 1 });
    };
}



// WEBPACK FOOTER //
// ./src/components/calendar/Calendar.tsx